import { render, staticRenderFns } from "./Gamepdf.vue?vue&type=template&id=6a7b16a2&scoped=true&"
import script from "./Gamepdf.vue?vue&type=script&lang=js&"
export * from "./Gamepdf.vue?vue&type=script&lang=js&"
import style0 from "./Gamepdf.vue?vue&type=style&index=0&id=6a7b16a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7b16a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VApp,VBtn,VDataTable,VIcon})
